import {SettingParam} from "@/types/node";
import {Textarea} from "@/components/ui/textarea";
import {useEffect, useState} from "react";

export const SettingTextarea = ({
  param,
  handleChange,
  selectedNodeId,
  disabled = false,
}: {
  param: SettingParam;
  handleChange: (param: SettingParam, value: string) => void;
  selectedNodeId: string;
  disabled: boolean;
}) => {
  const [value, setValue] = useState(param.value?.toString() || "");

  useEffect(() => {
    setValue(param.value?.toString() || "");
  }, [param, selectedNodeId]);
  return (
    <div className="mb-4 w-full">
      <label className="text-sm font-medium text-label mb-2 flex items-center justify-between">
        {param.label}
      </label>
      <Textarea
        onChange={e => {
          setValue(e.target.value);
          handleChange(param, e.target.value);
        }}
        value={value}
        placeholder={param.placeholder}
        disabled={disabled}
        className={disabled ? "pointer-events-none bg-muted !opacity-100" : ""}
      />
    </div>
  );
};
